import { IFeatureToggleApi } from '../api/featureToggleApi'
import { parseFeatureToggleMap, parseFeatureToggleMapV2 } from '../util/featureToggleParser'
import { useFeatureToggleStore } from '../store/featureToggelStore'
import { useFeatureToggleV2Store } from '../store/featureToggleV2Store'

export class FeatureToggleService {
  private _api: IFeatureToggleApi
  constructor(api: IFeatureToggleApi) {
    this._api = api
  }

  /**
   * @deprecated 未來遊戲不再支援 v1 的 toggles，請改用 `getFeatureToggleV2`。
   */
  async getFeatureToggle(): Promise<void> {
    const toggleString = await this._api.getFeatureToggle()
    const toggleList = parseFeatureToggleMap(toggleString)
    useFeatureToggleStore.setState({
      toggleList,
    })
  }

  async getFeatureToggleV2(): Promise<void> {
    const toggleList = await this._api.getFeatureToggleV2()
    const toggleListV2 = parseFeatureToggleMapV2(toggleList)
    useFeatureToggleV2Store.getState().addV2ToggleSet(toggleListV2)
  }
}
